import Model from "./model"

export default Model